import React from 'react';

import s from './style.module.css';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};

/**
 * An inline link-looking button for actions living inside a sentence: the
 * resend footnote and the conflict errors, as on the b2b auth card.
 */
const LinkButton: React.VFC<Props> = ({ onClick, disabled, children }) => (
  <button className={s.linkButton} onClick={onClick} disabled={disabled} type="button">
    {children}
  </button>
);

export { LinkButton };
